import React, { useState } from 'react';
import 'react-phone-number-input/style.css';
import './style.scss';
import PhoneInput from 'react-phone-number-input';
import flags from 'react-phone-number-input/flags';
interface Props {
  placeholder: string;
  name: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: (event: CustomEvent<FocusEvent>) => void;
  innerRef: React.MutableRefObject<any>;
}

const EnhancedPhoneInput: React.FC<Props> = (props) => {
  const [value, setValue] = useState(props.value);

  return (
    <PhoneInput
      flags={flags}
      name={props.name}
      defaultCountry="FR"
      value={value}
      autoComplete="new-password"
      placeholder={props.placeholder}
      className="custom-input"
      onChange={(value: string) => {
        setValue(value);
        props.onChange(value);
      }}
    />
  );
};

export default EnhancedPhoneInput;
